import { BLAuth } from "@brandlive/client-auth";
import { API_HOST } from "@/utils/connections/endpoints";

export default new BLAuth(API_HOST, process.env.REACT_APP_LOGIN_HOST as string);